import { Pipe, PipeTransform } from '@angular/core';
import { min } from 'rxjs';

@Pipe({
  name: 'formatDateTime',
  standalone:true

})
export class FormatDateTimePipe implements PipeTransform {

  transform(value: string, mode: 'date' | 'time' | 'return-date' | 'return-time' = 'date'): string {
    if (!value) return value;

    const year = +value.slice(0, 4);
    const month = +value.slice(4, 6) - 1;
    const day = +value.slice(6, 8);
    const hour = +value.slice(8, 10);
    const minute = +value.slice(10, 12);
    const second = +value.slice(12, 14);

    const date = new Date(year, month, day, hour, minute, second);

    if (mode === 'date') {
      return date.toLocaleString('en-GB');
    } else if (mode === 'time') {
      return date.toLocaleString('en-GB', { hour12: false });
    } else if (mode === 'return-date') {
      let formatDate = date.toLocaleDateString('en-GB');
      return formatDate.replace(/\//g, '-')
    } else if (mode === 'return-time') {
      return date.toLocaleTimeString('en-GB');
    }
    return value;
  }
}
